import { PlaceholderPage } from "@/components/PlaceholderPage";

export default function Exchange() {
  return (
    <PlaceholderPage
      title="Exchange"
      description="Trading exchange interface coming soon."
    />
  );
}
